export default "__VITE_ASSET__77157cd9__"